import { getTourIdFromQueryParams } from './urlUtils';
import { getLinkedTourState } from './linkedTourUtils';

/**
 * Get the current tour ID from query params or linked tour storage.
 * Returns the tour ID from query params if available, otherwise from linked tour.
 * Returns null if no tour ID is found.
 */
export const getCurrentTourId = () => {
  var _getLinkedTourState;
  return getTourIdFromQueryParams() || ((_getLinkedTourState = getLinkedTourState()) === null || _getLinkedTourState === void 0 ? void 0 : _getLinkedTourState.tourId) || null;
};
export const shouldRenderTour = tourId => {
  const currentTourId = getCurrentTourId();
  if (!tourId) {
    return !!currentTourId;
  }
  if (typeof tourId === 'string') {
    return currentTourId === tourId;
  }
  if (currentTourId && Array.isArray(tourId)) {
    return tourId.includes(currentTourId);
  }
  return false;
};